const UPI_PAYMENT_METHOD_PREFIX = "pm_upi";
const UPI_INTENT_PAYMENT_METHOD_PREFIX = "pm_ui";

export const UPI_PAYMENT_METHOD_TEST_IDS = {
    CONTAINER: `${UPI_PAYMENT_METHOD_PREFIX}_container`,
    ICON: `${UPI_PAYMENT_METHOD_PREFIX}_icon`,
    NAME: `${UPI_PAYMENT_METHOD_PREFIX}_name`,
    DISABLE_MESSAGE: `${UPI_PAYMENT_METHOD_PREFIX}_disable_msg`,
    TICK: `${UPI_PAYMENT_METHOD_PREFIX}_tick`,
    PAY_BUTTON: `${UPI_PAYMENT_METHOD_PREFIX}_pay_btn`,
};

export const UPI_INTENT_PAYMENT_METHOD_TEST_IDS = {
    CONTAINER: `${UPI_INTENT_PAYMENT_METHOD_PREFIX}_container`,
    ICON: `${UPI_INTENT_PAYMENT_METHOD_PREFIX}_icon`,
    NAME: `${UPI_INTENT_PAYMENT_METHOD_PREFIX}_name`,
    DISABLE_MESSAGE: `${UPI_INTENT_PAYMENT_METHOD_PREFIX}_disable_msg`,
    TICK: `${UPI_INTENT_PAYMENT_METHOD_PREFIX}_tick`,
    PAY_BUTTON: `${UPI_INTENT_PAYMENT_METHOD_PREFIX}_pay_btn`,
};
